import WhatsNext from "./WhatsNext";

export default WhatsNext;
export { WhatsNext };
